
import React from "react";
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from "@/components/ui/select";
import { Control, Path, PathValue, UseFormSetValue, useWatch } from "react-hook-form";
import { FormFieldType } from "@/types/form";
import FieldWrapper from "../fields/FieldWrapper";

interface TimePickerFieldProps<TFieldValues extends Record<string, any>> {
  control: Control<TFieldValues>;
  setValue: UseFormSetValue<TFieldValues>;
  name: Path<TFieldValues>;
  field: FormFieldType;
}

export const TimePickerField = <TFieldValues extends Record<string, any>>(
  props: TimePickerFieldProps<TFieldValues>
) => {
  // Use useWatch to get the current value of the field
  const fieldValue = useWatch({
    control: props.control,
    name: props.name
  }) as string | undefined;

  // Extract hour and minute from stored value if it exists
  const [hour, minute] = fieldValue ? fieldValue.split(":") : ["", ""];

  const handleHourChange = (newHour: string) => {
    const newValue = `${newHour}:${minute || "00"}`;
    props.setValue(props.name, newValue as unknown as PathValue<TFieldValues, Path<TFieldValues>>);
  };

  const handleMinuteChange = (newMinute: string) => {
    const newValue = `${hour || "09"}:${newMinute}`;
    props.setValue(props.name, newValue as unknown as PathValue<TFieldValues, Path<TFieldValues>>);
  };

  // Generate hours from 06 to 22
  const hours = Array.from({ length: 17 }, (_, i) => {
    const hourValue = i + 6;
    return hourValue < 10 ? `0${hourValue}` : `${hourValue}`;
  });

  // Minutes options are 00 and 30
  const minutes = ["00", "30"];

  return (
    <FieldWrapper element={props.field}>
      <div className="flex space-x-2">
        <div className="flex-1">
          <Select
            value={hour}
            onValueChange={handleHourChange}
          >
            <SelectTrigger>
              <SelectValue placeholder="ชั่วโมง" />
            </SelectTrigger>
            <SelectContent>
              {hours.map((h) => (
                <SelectItem key={h} value={h}>{h}</SelectItem>
              ))}
            </SelectContent>
          </Select>
        </div>
        <div className="flex items-center">:</div>
        <div className="flex-1">
          <Select
            value={minute}
            onValueChange={handleMinuteChange}
          >
            <SelectTrigger>
              <SelectValue placeholder="นาที" />
            </SelectTrigger>
            <SelectContent>
              {minutes.map((m) => (
                <SelectItem key={m} value={m}>{m}</SelectItem>
              ))}
            </SelectContent>
          </Select>
        </div>
      </div>
    </FieldWrapper>
  );
};

export default TimePickerField;
